import React from 'react'
import laptop from '../../img/laptop.jpg'
const Laptop = () => {
  return <img src={laptop}></img>
}

export default Laptop
